export default "__VITE_ASSET__4dec6a9a__"